





































import Vue from "vue";
import { mapState } from "vuex";
import BottomNavigation from "../components/common/bottom-navigation/bottom-navigation.vue";
import BottomNavigationItem from "../components/common/bottom-navigation/bottom-navigation-item.vue";

export default Vue.extend({
  components: { BottomNavigation, BottomNavigationItem },
  data() {
    return {
      isCollapsed: false,
      hoverCollapseToggled: false,
      currentMenuItemName: "past-due",
      showCancelAccount: false,
      showPlanSelector: false,
    };
  },
  computed: {
    ...mapState("billing", ["loading"]),
    pageTitle() {
      let title = "";
      switch (this.currentMenuItemName) {
        case "past-due":
          title = "Subscriptions Past Due";
          break;
        case "canceled":
          title = "Subscriptions Canceled";
          break;
      }

      return title;
    },
  },
  mounted() {
    this.$Notice.config({
      top: 120,
      duration: 3,
    });

    this.load();
  },
  beforeDestroy() {},
  methods: {
    handleMenuSelect(name) {
      this.currentMenuItemName = name;
      //this.$store.dispatch("goal/setActiveMenu", name);

      //if (this.lastMenuItemName === "checkins" && (this as any).currentGoalHasCheckpointUpdated === true) {
      //  this.loadGoal();
      //}
      //this.lastMenuItemName = name;
    },
    load() {
      let context = this as any;
      // this.$store
      //   .dispatch("billing/getFreeTrials")
      //   .then((response) => {})
      //   .finally(() => {});
    },
  },
});
